var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWifihalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24px/Wifi"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3069 10.998C18.0294 8.7033 15.0796 7.4396 12.0008 7.43969C8.9214 7.43974 5.97156 8.70349 3.69475 10.9981C3.33006 11.3657 3.33236 11.9592 3.6999 12.3239C4.06745 12.6886 4.66103 12.6863 5.02572 12.3188C6.94782 10.3816 9.42498 9.31474 12.0008 9.31469C14.5761 9.3146 17.0532 10.3815 18.976 12.3189C19.1593 12.5035 19.4003 12.5959 19.6415 12.5959C19.8801 12.5959 20.119 12.5053 20.3019 12.3238C20.6694 11.9591 20.6716 11.3655 20.3069 10.998Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9921 12.9219C13.5869 12.9219 15.3352 13.6725 16.5549 14.8809C16.9227 15.2453 16.9255 15.8389 16.561 16.2067C16.1967 16.5746 15.603 16.5772 15.2352 16.2129C14.367 15.3527 13.094 14.7969 11.992 14.7969H11.9916H11.9237H11.9233C10.8211 14.7969 9.54816 15.3526 8.6799 16.2129C8.49713 16.3939 8.25859 16.4844 8.02013 16.4844C7.77878 16.4844 7.53746 16.3917 7.35413 16.2067C6.98973 15.8388 6.99249 15.2453 7.36028 14.8809C8.57991 13.6725 10.3284 12.9219 11.9232 12.9219H11.9239H11.9914H11.9921Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1.5,
    fill: "#2C2C2C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWifihalf);
export default __webpack_public_path__ + "static/media/ic_wifihalf.11dee8280cd4a75b54fd6fb116df32df.svg";
export { ForwardRef as ReactComponent };